import { jsx } from "react/jsx-runtime";
import WarningIcon from "@mui/icons-material/Warning";
import { validateTidalLicense } from "../../base/index.js";
function Warning(props) {
  return /* @__PURE__ */ jsx(
    WarningIcon,
    {
      "data-testid": "Warning",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Warning",
      "data-tidal-icon-meta": "cancel,informative"
    }
  );
}
Warning.tidalIconMeta = {
  categories: "cancel,informative",
  name: "Warning"
};
validateTidalLicense();
export {
  Warning
};
//# sourceMappingURL=Warning.js.map
